export enum PermissionAddon {
  Unregistered = 'unregistered',
  PaperApp = 'PaperApp',
}

export type NonCapabilityAddon = PermissionAddon.Unregistered;

export type Capability = Exclude<PermissionAddon, NonCapabilityAddon>;
